import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import './index.css'
import './globals.scss'

const applySystemTheme = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const rootElement = document.documentElement

  if (prefersDark) {
    rootElement.classList.add('theme-dark')
  } else {
    rootElement.classList.remove('theme-dark')
  }
}

applySystemTheme()

if (typeof window !== 'undefined') {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', applySystemTheme)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } else if ((mediaQuery as any).addListener) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(mediaQuery as any).addListener(applySystemTheme)
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
